import type { TransferOrderWorkspaceQueue } from '../transfer-order-workspace-queues.js';
import { isStatusCompatibleWithQueue } from './is-status-compatible-with-queue.js';

export function compatibleStatusIds(
  queue: TransferOrderWorkspaceQueue,
  statusIds: readonly number[],
): number[] {
  return statusIds.filter((statusId) => isStatusCompatibleWithQueue(queue, statusId));
}
